(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_article_content"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  const $content = $(".custom_article_content_main");
  const $tocContainer = $(".custom-jj-item");

  $content.find("h2, h3, h4").each(function (index) {
    const $heading = $(this);
    const tag = $heading.prop("tagName").toLowerCase();
    const text = $heading.text().trim();
    
    // Generate unique slug-based ID
    const id = text.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '') + '-' + index;
    $heading.attr("id", id);

    // Create TOC link
    const $link = $('<a></a>')
      .attr("href", "#" + id)
      .text(text)
      .addClass("toc-link toc-" + tag);

    $tocContainer.append($link);
  });

  // Optional: smooth scroll (if desired and supported)
  $("html").css("scroll-behavior", "smooth");
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customs_collections_metas"] && !Shopify.designMode) return;
  try {
    
    function toggleSlick() {
    const $slider = $('.custom_collection_grid.over-content-product');
    const breakpoint = 991;

    if (window.innerWidth > breakpoint) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.removeClass('slick-disabled').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    } else {
      if (!$slider.hasClass('slick-disabled')) {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
        $slider.addClass('slick-disabled');
      }

      if (!$slider.hasClass('slick-initialized')) {
        $slider.removeClass('slick-disabled').slick({
          centerMode: true,
          centerPadding: '40',
          slidesToShow: 1
        });
      }
    }
  }

  $(document).ready(function () {
    toggleSlick();
  });

  let resizeTimeout;
  $(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(toggleSlick, 150); // Debounce resize
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  const tabItems = document.querySelectorAll(".our_composition_slider_item");
  const tabButtonsWrapper = document.createElement("div");
  tabButtonsWrapper.className = "our_composition_tab_buttons";

  tabItems.forEach((item, index) => {
    const heading = item.querySelector(".our_composition_item_heading")?.innerText || `Tab ${index + 1}`;
    const button = document.createElement("button");
    button.innerText = heading;
    button.dataset.index = index;

    button.addEventListener("click", function () {
      // Toggle tab content
      tabItems.forEach(el => el.classList.remove("active"));
      tabItems[index].classList.add("active");

      // Toggle button states
      tabButtonsWrapper.querySelectorAll("button").forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");
    });

    if (index === 0) {
      button.classList.add("active");
      item.classList.add("active");
    }

    tabButtonsWrapper.appendChild(button);
  });

  const parent = document.querySelector(".our_composition_slider");
  parent.parentNode.insertBefore(tabButtonsWrapper, parent);
});

  } catch(e) { console.error(e); }
})();
})();
